module.exports = __webpack_public_path__ + "static/media/diva55.bc47cb3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diva/diva55.jpg
// module id = 601
// module chunks = 0